import { Controller } from 'stimulus';

class OrderListModalController extends Controller {
  static targets = ['addToOrderListForm'];

  onShowModal() {
    $(this.element).find('.modal').modal('show');
  }

  onHideModal() {
    $(this.element).find('.modal').modal('hide');
  }

  onAddToOrderList() {
    if (!this.orderListCheckboxTargets.length || !this.element.getAttribute('data-route')) {
      return;
    }

    const orderLists = [];

    this.orderListCheckboxTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        orderLists.push(checkbox.value);
      }
    });

    $.ajax({
      url: this.element.getAttribute('data-route'),
      method: 'POST',
      data: {
        orderLists,
        quantity: this.quantityTarget.value,
      },
    })
      .then(() => {
        this.onHideModal();
      });
  }
}

OrderListModalController.targets = [
  'addToOrderListForm',
  'orderListCheckbox',
  'quantity',
];

export default OrderListModalController;
